import React from 'react';
import PropTypes from 'prop-types'

const LoadingSpinnerView = ({text, inline}) => (<div className={'large active indeterminate text loader' + (inline ? ' inline' : '')}>{ text }</div>);

LoadingSpinnerView.propTypes = {
    text: PropTypes.string,
    inline: PropTypes.bool
};

LoadingSpinnerView.defaultProps = {
    text: 'Loading...',
    inline: false
};

export default LoadingSpinnerView;
